"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles = require('./NavigationListMenu.module.scss');
const NavigationListMenu = ({ children, className = '' }) => (react_1.default.createElement("ul", { className: (0, classnames_1.default)(styles.root, { [className]: !!className }) }, children));
exports.default = NavigationListMenu;
//# sourceMappingURL=NavigationListMenu.js.map